import Flickity from "flickity";

const Testimonials = () => {

    // Find all sliders on the page with the given class selector
    const testimonials = document.querySelectorAll('.testimonials__slides');

    // Loop through each slider and initialize Flickity if it has multiple slides
    testimonials.forEach(slider => {
        const slideCount = slider.querySelectorAll('.testimonials__slide').length;
        const hasMultipleSlides = slideCount > 1;
        // Fetch any custom previous and next button elements
        const previousButton = slider.querySelector('[data-testimonial-previous]');
        const nextButton = slider.querySelector('[data-testimonial-next]');


        if (hasMultipleSlides) {
            const flickity = new Flickity(slider, {
                adaptiveHeight: false,
                autoPlay: false,
                cellSelector: '.testimonials__slide',
                draggable: true,
                fade: false,
                pageDots: true,
                prevNextButtons: false,
                wrapAround: true,
            });

            // If we have a previous button, add a click handler to select the previous slide
            if (typeof previousButton != 'undefined' && previousButton != null) {
                previousButton.addEventListener('click', () => {
                    // true = slides wrapAround
                    flickity.previous(true);
                });
            }

            // If we have a next button, add a click handler to select the next slide
            if (typeof nextButton != 'undefined' && nextButton != null) {
                nextButton.addEventListener('click', () => {
                    // true = slides wrapAround
                    flickity.next(true);
                });
            }
        }
    });
}
  
export default Testimonials;
